import { EnderecoLocalTipo } from './endereco-local-tipo.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class EnderecoLocalTipoService {

    constructor(private http: Http) {
    }

    getEnderecoLocalTipo(): Observable<EnderecoLocalTipo[]> {
        return this.http.get(`${NTECH_API}/endereco-local-tipo`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}


// WEBPACK FOOTER //
// ./src/app/endereco-local-tipo/endereco-local-tipo.service.ts